import styled from 'styled-components';
import { Flex, FlexProps } from '../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'BusinessRegistrationAccount' })
    .attrs<FlexProps>({
        p: 2,
        borderRadius: 2,
        borderTopLeftRadius: { xs: 0, sm: 2 },
        borderTopRightRadius: { xs: 0, sm: 2 },
        width: '100%',
        height: '100%',
        backgroundColor: 'var(--background-primary)',
    })``;
